import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {LocalStorageAssistantRepository} from '../Repositories/LocalStorageAssistantRepository.js'

class ClearAssistantChatUseCase extends UseCase {
  #repository

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create({config}) {
    return new ClearAssistantChatUseCase({
      repository: LocalStorageAssistantRepository.create({config})
    })
  }

  @tracer({metric: 'ClearAssistantChatUseCase#execute'})
  @AsyncInlineError()
  async execute({chatId} = {}) {
    this.#repository.deleteChatById(chatId)
  }
}

export const factory = ClearAssistantChatUseCase.create
